// extracted by mini-css-extract-plugin
export default {"base":"UwvQ8","userImage":"t_igV","hidden":"OEhNQ","tiny":"YZUII","letter":"xdSnr","small":"irMVg","medium":"y4BoR","large":"ZcTP3"};